import { getAIToolsGates } from './aiToolsGating'

export const AUTH_SESSION_KEY = '_voshi_session'

export const attachAIToolsPreloadRetry = (params, preloadAITools) => {
  if (!params?.userid || !getAIToolsGates(params).preloadBundle) {
    return
  }

  let attached = false
  let completed = false
  let authListener = null
  let authWebcompRef = null

  const cleanup = () => {
    if (authWebcompRef && authListener) {
      authWebcompRef.removeEventListener('vapp-auth-change', authListener)
    }
    authWebcompRef = null
    authListener = null
    attached = false
  }

  const attachListener = () => {
    const session = window[AUTH_SESSION_KEY]
    const authWebcomp = session?.webcomp
    if (!authWebcomp || attached || completed) {
      return false
    }

    authListener = () => {
      if (completed || !window[AUTH_SESSION_KEY]?.ready) {
        return
      }

      completed = true
      cleanup()
      void preloadAITools(params)
    }

    authWebcompRef = authWebcomp
    authWebcompRef.addEventListener('vapp-auth-change', authListener)
    attached = true

    if (session?.ready) {
      authListener()
    }

    return true
  }

  if (attachListener()) {
    return
  }

  let attempts = 0
  const intervalId = setInterval(() => {
    attempts += 1
    if (completed || attachListener() || attempts >= 50) {
      clearInterval(intervalId)
    }
  }, 100)
}
